<template>
    <PopupRouterView :showLeftIcon="true" label="Work Order Execution Ng Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="workorderexecutionng"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="workOrderExecutionNgInput">


        <b-card header="Work Order Execution Ng" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="problemCategorys" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Ng Category" id="fieldset-ng-category" size="sm" :model.sync="model.ngCategoryId"   :selected="model.ngCategory != null ? model.ngCategory.code : ''" @input="getProblemCategorys"   :isSelectMethodExists="true" @onSelectMethod="setSelectedNgCategory" />
						<app-input-textbox id="fieldset-ng-qty" label-cols-lg="12"  label="Ng Qty" label-for="input-ng-qty" size="sm" :model.sync="model.ngQty"   />
						<app-input-combobox-autocomplete :options="workOrderExecutionDetails" optionsLabel="workOrderProcessDetail" optionsKey="id" label-cols-lg="12" label="Work Order Execution Detail Id" id="fieldset-work-order-execution-detail" size="sm" :model.sync="model.workOrderExecutionDetailId"   :selected="model.workOrderExecutionDetail != null ? model.workOrderExecutionDetail.workOrderProcessDetail : ''" @input="getWorkOrderExecutionDetails"   :isSelectMethodExists="true" @onSelectMethod="setSelectedWorkOrderExecutionDetail" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import WorkOrderExecutionNg from '@/models/WorkOrderExecutionNg/WorkOrderExecutionNg';
import WorkOrderExecutionNgList from '@/models/WorkOrderExecutionNg/WorkOrderExecutionNgList';
import WorkOrderExecutionNgFilter from '@/filters/WorkOrderExecutionNg/WorkOrderExecutionNgFilter';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ProblemCategory from '@/models/ProblemCategory/ProblemCategory';
import ProblemCategoryFilter from '@/filters/ProblemCategory/ProblemCategoryFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import WorkOrderExecutionDetail from '@/models/WorkOrderExecution/WorkOrderExecutionDetail';
import WorkOrderExecutionDetailFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionDetailFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterWorkOrderExecutionNg : null,
			currentWorkOrderExecutionNgPage : 1,
			workOrderExecutionNgPageSize: 10,
			sortByWorkOrderExecutionNg: '',
			sortDescWorkOrderExecutionNg: '',
			problemCategorys: [],
			ngCategorys: [],
			isNgCategoryComboLoading: false,
			workOrderExecutionDetails: [],
			workOrderExecutionDetails: [],
			isWorkOrderExecutionDetailComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isProblemCategoryComboLoading: false,
			isWorkOrderExecutionDetailComboLoading: false,
		}
	},
	methods : {
		getWorkOrderExecutionNg : async function(id) {
			this.isBusy = true;
			WorkOrderExecutionNg.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadWorkOrderExecutionNg = true;
			this.filterWorkOrderExecutionNg.id = this.modelId;
			WorkOrderExecutionNg.downloadDataDetail(this, this.filterWorkOrderExecutionNg).then(result => {
				this.isDownloadWorkOrderExecutionNg = false;
			}).catch(error => { this.isDownloadWorkOrderExecutionNg = false; })
		},
		getWorkOrderExecutionNgs : async function(input) {
			let filter = new WorkOrderExecutionNgFilter();
			if (input != undefined) {
				filter.WorkOrderExecutionDetail = input;
			}
			this.isWorkOrderExecutionNgComboLoading = true;
			WorkOrderExecutionNg.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderExecutionNgs = result.data
				}
				this.isWorkOrderExecutionNgComboLoading = false;
			})
			.catch(error => {});
		},
		getProblemCategorys : async function(input) {
			let filter = new ProblemCategoryFilter();
			if (input != undefined) {
				filter.code = input;
			}
			ProblemCategory.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.problemCategorys = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedNgCategory(item) {
			if(item == undefined || item == null) {
				this.model.ngCategoryId = null;
				this.model.ngCategory = null;
			} else {
				this.model.ngCategoryId = item.id;
				this.model.ngCategory = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getWorkOrderExecutionDetails : async function(input) {
			let filter = new WorkOrderExecutionDetailFilter();
			if (input != undefined) {
				filter.workOrderProcessDetail = input;
			}
			WorkOrderExecutionDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderExecutionDetails = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderExecutionDetail(item) {
			if(item == undefined || item == null) {
				this.model.workOrderExecutionDetailId = null;
				this.model.workOrderExecutionDetail = null;
			} else {
				this.model.workOrderExecutionDetailId = item.id;
				this.model.workOrderExecutionDetail = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.workOrderExecutionNgInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						WorkOrderExecutionNg.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'workorderexecutionngindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						WorkOrderExecutionNg.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'workorderexecutionngindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					WorkOrderExecutionNg.updateData(this, model, id)
					.catch((error) => {
						this.getWorkOrderExecutionNg(id);
					});
				}
			});
		},
		onHidden() {
			this.getWorkOrderExecutionNgs();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterWorkOrderExecutionNg = new WorkOrderExecutionNgFilter();
		//this.getProblemCategorys();
		//this.getWorkOrderExecutionDetails();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getWorkOrderExecutionNg(id);
			} else {
				this.modelId = id;
				this.getWorkOrderExecutionNg(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
